module.exports = __webpack_public_path__ + "static/media/setup-analytics.dd2288fc.svg";